import React, { useContext, useEffect, useRef, useState } from "react";
import { MyContext } from "../../App";
import { fetchDataFromApi } from "../../utils/api";
import ProductItem from "../../Components/ProductItem";
import NoProductsFound from "../../Components/NoProductsFound";

const PopularProducts = () => {
  const [selectedCat, setSelectedCat] = useState();
  const [filterData, setFilterData] = useState([]);
  const [value, setValue] = useState(0);
  const [isLoading, setIsLoading] = useState(true); // Initially set to true to show skeleton loader
  const [error, setError] = useState(null); // Error state
  const context = useContext(MyContext);
  const filterSlider = useRef();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const selectCat = (cat) => {
    setSelectedCat(cat);
  };

  useEffect(() => {
    if (context?.categoryData && context?.categoryData.length > 0) {
      // If categoryData is not empty, set the first category name
      setSelectedCat(context?.categoryData[0]?.name || "No Category");
    } else {
      // If categoryData is empty or undefined, set a default value
      setSelectedCat("No Categories Available");
    }
  }, [context?.categoryData]);

  useEffect(() => {
    if (selectedCat !== undefined) {
      setIsLoading(true); // Start loading

      // Reset error state before making the API call
      setError(null);

      fetchDataFromApi(`/api/products/catName?catName=${selectedCat}`)
        .then((res) => {
          // If the response has a valid product list, set the data
          if (res.products && Array.isArray(res.products)) {
            setFilterData(res.products);
          } else {
            // If products are not valid, set empty array
            setFilterData([]);
          }
          setIsLoading(false); // Stop loading
          if (filterSlider.current) {
            filterSlider.current.scrollLeft = 0;
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setError("Failed to load popular products. Please try again later.");
          setIsLoading(false); // Stop loading on error
        });
    }
  }, [selectedCat]);

  const SkeletonProductItem = () => (
    <div className="productItem bg-gray-200 rounded-lg w-[246px] h-[331px] m-2.5 overflow-hidden relative">
      {/* Skeleton for the Image */}
      <div className="w-full h-[250px] bg-gray-300 rounded-t-lg animate-pulse"></div>

      {/* Skeleton for the Content */}
      <div className="p-2.5">
        <div className="w-3/4 h-6 bg-gray-300 mb-2.5 animate-pulse"></div>
        <div className="w-1/2 h-5 bg-gray-300 animate-pulse"></div>
      </div>

      {/* Shimmer Effect */}
      <div
        className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-75"
        style={{
          backgroundSize: "200% 100%",
          animation: "shimmer 1.5s infinite",
        }}
      ></div>
    </div>
  );

  // Global CSS for the shimmer animation
  const styles = `
    @keyframes shimmer {
      0% {
        transform: translateX(-100%);
      }
      100% {
        transform: translateX(100%);
      }
    }
  `;

  // Dynamically append the shimmer styles to the document head
  const appendStyles = () => {
    if (!document.getElementById("skeletonStyles")) {
      const styleTag = document.createElement("style");
      styleTag.id = "skeletonStyles";
      styleTag.innerHTML = styles;
      document.head.appendChild(styleTag);
    }
  };

  // Call the function to append styles
  appendStyles();

  return (
    <>
      <div className="d-flex align-items-center res-flex-column">
        <div className="info" style={{ width: "35%" }}>
          <h3 className="mb-0 hd">Popular Products</h3>
        </div>

        <div
          className="ml-auto d-flex align-items-center justify-content-end res-full hidden sm:flex"
          style={{ width: "65%" }}
        >
          {/* <div className="filterTabs flex overflow-x-auto">
            {context.categoryData?.map((item, index) => (
              <button
                key={index}
                className={`item mx-2.5 py-2.5 px-5 border-none bg-transparent cursor-pointer ${value === index ? "active" : ""
                  }`}
                onClick={() => {
                  selectCat(item.name);
                  handleChange(null, index);
                }}
              >
                {item.name}
              </button>
            ))}
          </div> */}
          <div className="filterTabs flex overflow-x-auto">
            {context.categoryData?.map((item, index) => (
              <button
                key={index}
                className={`item mx-2.5 py-2.5 px-5 border-none bg-transparent cursor-pointer relative ${
                  value === index ? "active" : ""
                }`}
                onClick={() => {
                  selectCat(item.name);
                  handleChange(null, index);
                }}
              >
                {item.name}
                {/* Add the underline */}
                {value === index && (
                  <div className="absolute bottom-0 left-0 w-full h-[2px] bg-green-500"></div>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div
        className="product_row w-full mt-2"
        style={{
          opacity: isLoading ? "0.5" : "1", // Dim the UI while loading
        }}
      >
        <div
          ref={filterSlider}
          className={`${
            context.windowWidth > 992 ? "mySwiper" : "productScroller"
          } flex overflow-x-auto scroll-smooth`}
        >
          {isLoading ? (
            // Show skeleton items while loading
            Array(3)
              .fill()
              .map((_, index) => <SkeletonProductItem key={index} />)
          ) : filterData?.length !== 0 ? (
            // Show actual products if data is available
            filterData?.slice(0)?.map((item, index) => (
              <div
                key={index}
                className="md:min-w-[250px] md:mx-2.5 md:h-[400px] productItem bg-gray-200 rounded-lg w-[250px] h-[375px] m-2.5 overflow-hidden relative"
              >
                <ProductItem item={item} />
              </div>
            ))
          ) : (
            // If no products are available, display the empty-state message
            <NoProductsFound />
          )}

          {context.windowWidth > 992 && (
            <div className="min-w-[250px] opacity-0">
              <div className="productItem"></div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PopularProducts;
